import React, { FC } from 'react';
import './index.scss';
import { StaticImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';

const Footer = React.forwardRef<HTMLDivElement, {}>(function Footer({}, ref) {
  const currentYear = new Date().getFullYear();

  return (
    <footer id='footer' key='footer' ref={ref}>
      © {currentYear} ONEFAM Barbershop
    </footer>
  );
});

export default Footer;
